import { Button, Checkbox, Col, Form, Input, Row, Select, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { BaseURL } from "../../../constants/enum/baseURL.emum";
import kpiList from "../../../constants/enum/kpi";
import doc3Service from "../../../services/doc3.service";
import scheduleService from "../../../services/schedule.service";

const BtnSendDoc3 = (props: {
  schedule: any;
  curri: any;
  course: any;
  responsible: string;
  group:string;
}) => {
  const user = JSON.parse(localStorage.getItem("user") ?? "false");
  const { schedule, curri, course, responsible ,group} = props;
  const [show, setShow] = useState(false);
  const [kpi, setKpi] = useState<
    {
      id: string;
      value: string;
      name: string;
    }[]
  >([]);

  const groupNew = group.length>0 ? [...group.split(',')]:[];

  useEffect(() => {
    if (curri.type === "tqf") {
      setKpi(kpiList.kpiTQF);
    } else {
      setKpi(kpiList.kpiMhesi);
    }
  }, []);
  // console.log(curri);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // console.log(schedule);
  const [sche, setSche] = useState<any>({});
  useEffect(() => {
    (async () => {
      await scheduleService.getById(schedule).then((res) => {
        setSche(res.data);
      });
    })();
  }, []);

  ///////////// for form antd ////////////////
  const onFinish = async (values: any) => {
    const { teacher, manage, kpi, checkBox } = values;

    const actSTD = checkBox ? checkBox : [];

    await doc3Service
      .createDoc3({
        ...values,
        checkBox: actSTD,
        manage,
        teacher: [...teacher, manage],
        course: course.course.id,
        schedule: schedule,
      })
      .then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "บันทึกสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          handleClose();
          window.location.reload();
        });
      })
      .catch(() => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "มีความผิดพลาดบางอย่าง",
          showConfirmButton: false,
          timer: 1500,
        });
      });
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const normFile = (e: any) => {
    // console.log("upload file:", e);
    if (Array.isArray(e)) {
      return e;
    }

    return e && e.fileList;
  };
  const propsUploadDoc3 = {
    naem: "file",
    action: `${BaseURL.BASE_URL}/upload/doc3`,
    onChange: (info: any) => {
      return info;
    },
  };
  ///////////// for form antd ////////////////
  const type = curri.type === "tqf" ? "มคอ." : "อชว.";

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary"
        onClick={handleShow}
      >
        <i className="bi bi-cloud-arrow-up-fill"></i> ส่ง {type}3
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        // centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            ส่งเอกสาร {type}3 ประจำปีการศึกษา {sche.year} เทอม {sche.term}
          </Modal.Title>
        </Modal.Header>

        <Form
          name="basic"
          // labelCol={{ span: 8 }}
          // wrapperCol={{ span: 16 }}
          initialValues={{
            name: "",
            sendBy: `${user.firstName} ${user.lastName}`,
            checkBox: ["activitySTD"],
            kpi: [],
            doc5:[...groupNew]
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Modal.Body>
            <div className="row g-3">
              
                <div className="col-12"><h6>
                  หลักสูตร : {curri.name} ({curri.shortName})
                </h6></div>
                <div className="col-12">
                  รายวิชา : {course.course.courseCode} วิชา{course.course.name} <br />
                  อาจารย์ผู้สอนตามรายวิชาที่เปิดสอน : {responsible} <br />
                  กลุ่มเรียนที่เปิดสอน : {group} <br />
                </div>
                
                <hr />
              
            </div>
            <div className="row">
              <div className="col-12">
                <label htmlFor="manage">อาจารย์ผู้รับผิดชอบรายวิชา</label>
                <Form.Item
                  name="manage"
                  rules={[
                    {
                      required: true,
                      message: "ระบุอาจารย์ผู้รับผิดชอบรายวิชา!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </div>

              <div className="col-12">
                <label htmlFor="doc5">กลุ่มเรียน</label>
                <p className="text-danger">
                  * ชื่อกลุ่มเรียนห้ามใช้เครื่องหมาย "/" <br />
                  * โปรดระบุกลุ่มเรียนให้ครบตามที่เปิดสอน
                </p>
                <Form.Item
                  name="doc5"
                  rules={[
                    { required: true, message: "ระบุกลุ่มเรียนด้วยครับ!" },
                  ]}
                >
                  <Select
                    mode="tags"
                    style={{ width: "100%" }}
                    onChange={(val) => {
                      // console.log(val);
                    }}
                    tokenSeparators={[","]}
                  ></Select>
                </Form.Item>
              </div>
              <div className="col-12">
                <label htmlFor="teacher">อาจารย์ผู้สอน</label>
                <Form.Item
                  name="teacher"
                  rules={[
                    { required: true, message: "ระบุอาจารย์ผู้สอนด้วยครับ!" },
                  ]}
                >
                  <Select
                    mode="tags"
                    style={{ width: "100%" }}
                    onChange={(val) => {
                      // console.log(val);
                    }}
                    tokenSeparators={[","]}
                  ></Select>
                </Form.Item>
                <p className="text-danger">
                  อัพโหลดได้เฉพาะไฟล์ PDF และอัพโหลดได้เพียง 1 ไฟล์เท่านั้น
                </p>
              </div>

              <Form.Item
                name="upload"
                label={`ไฟล์เอกสาร ${type}`}
                valuePropName="fileList"
                getValueFromEvent={normFile}
                rules={[{ required: true, message: "upload เอกสารด้วยครับ!" }]}
              >
                <Upload {...propsUploadDoc3} maxCount={1}>
                  <Button>Click to upload</Button>
                </Upload>
              </Form.Item>

              <Form.Item name="checkBox">
                <Checkbox.Group style={{ width: "100%" }}>
                  <Row>
                    <Col span={24}>
                      <Checkbox value="activitySTD">
                        มีการจัดกิจกรรมเน้นผู้เรียนเป็นสำคัญ
                      </Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>

              <Row>
                <Col>ตรงกับ KPI</Col>
              </Row>

              <Form.Item name="kpi">
                <Checkbox.Group style={{ width: "100%" }}>
                  {kpi.map((kpi: any) => {
                    return (
                      <Row key={kpi.id}>
                        <Col>
                          <Checkbox value={kpi.value}>{kpi.name}</Checkbox>
                        </Col>
                      </Row>
                    );
                  })}
                </Checkbox.Group>
              </Form.Item>

              <div className="col">
                <label htmlFor="sendBy">ผู้ส่งเอกสาร {type}3</label>
                <Form.Item
                  name="sendBy"
                  rules={[
                    { required: true, message: "Please input your username!" },
                  ]}
                >
                  <Input disabled />
                </Form.Item>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" className="btn btn-primary">
              เพิ่มข้อมูล
            </button>
            <button type="reset" className="btn btn-warning">
              ล้าง
            </button>

            <button
              type="button"
              className="btn btn-danger"
              onClick={handleClose}
            >
              Close
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default BtnSendDoc3;
